// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedReferenceMatching_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M19.2275 8.56581 17.3001 9.18508C16.8639 8.36556 16.2432 7.65917 15.4935 7.12134L16.4149 5.32747C17.6224 6.12799 18.6 7.2475 19.2275 8.56581ZM14.6225 4.43974C13.8009 4.1548 12.9186 4 12 4 11.4564 4 10.9255 4.05422 10.4124 4.15754L11.0294 6.0781C11.3454 6.02671 11.6696 6 12 6 12.5891 6 13.1583 6.08489 13.6962 6.2431L14.6225 4.43974ZM6.26772 10.2224 4.46787 9.29788C4.16502 10.142 4.00003 11.0517 4.00003 12 4.00003 12.4839 4.043 12.9578 4.12533 13.4181L6.05274 12.7988C6.01797 12.5375 6.00003 12.2708 6.00003 12 6.00003 11.3811 6.09373 10.7841 6.26772 10.2224ZM6.64506 14.7092 4.72248 15.3269C5.31307 16.6167 6.23648 17.7224 7.38281 18.5339L8.30904 16.7307C7.61649 16.1896 7.04581 15.4998 6.64506 14.7092ZM10.0686 17.6824 9.14713 19.4763C10.0333 19.8147 10.995 20 12 20 12.4652 20 12.9211 19.9603 13.3645 19.8841L12.7445 17.9543C12.5006 17.9845 12.2521 18 12 18 11.3243 18 10.6747 17.8883 10.0686 17.6824ZM14.6605 17.3794 15.2776 19.3C16.6145 18.6988 17.7564 17.7411 18.5824 16.548L16.7827 15.6236C16.2232 16.3609 15.4971 16.9648 14.6605 17.3794ZM17.7091 13.851 19.506 14.774C19.8255 13.9098 20 12.9753 20 12 20 11.4752 19.9495 10.9621 19.853 10.4655L17.9304 11.0832C17.9763 11.3821 18 11.6883 18 12 18 12.6459 17.898 13.268 17.7091 13.851ZM7.17122 8.43808C7.69177 7.73356 8.36281 7.14701 9.13687 6.72591L8.51682 4.79607C7.24525 5.41203 6.16142 6.35475 5.37443 7.51512L7.17122 8.43808Z" class="svg-bg"/>
  <path d="M0.241699 17.6338L22.7584 4.63379L23.7584 6.36584L1.2417 19.3658L0.241699 17.6338Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedReferenceMatching is a generated icon component.
 */
let IconMedReferenceMatching = IconMedReferenceMatching_1 = class IconMedReferenceMatching extends IconBaseElement {
    render() {
        return html `${IconMedReferenceMatching_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedReferenceMatching.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedReferenceMatching = IconMedReferenceMatching_1 = __decorate([
    customElement('zui-icon-med-reference-matching')
], IconMedReferenceMatching);
export { IconMedReferenceMatching };
